<template>
  <v-row>
    <v-col cols="12">
      <v-card :data-question-key="question.key || question.tempKey" class="question-card" elevation="5">
        <v-card-actions class="d-flex align-content-center">
          <v-icon v-if="question.group">mdi mdi-subdirectory-arrow-right</v-icon>

          <v-autocomplete v-model="question.type" :items="types" :label="$t('questions.select_type')"
                          hide-details
                          item-text="label"
                          item-value="value" outlined single-line></v-autocomplete>
          <v-spacer/>
          <v-menu top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs"
                     v-on="on">
                <v-icon>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item color="default" link @click="duplicateQuestion">
                <v-list-item-icon>
                  <v-icon>mdi mdi-content-duplicate</v-icon>
                </v-list-item-icon>
                <v-list-item-subtitle>
                  {{ $t('questions.duplicate') }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item color="error" link @click="deleteQuestion">
                <v-list-item-icon>
                  <v-icon>mdi mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-subtitle>
                  {{ $t('questions.delete_question') }}
                </v-list-item-subtitle>
              </v-list-item>

            </v-list>

          </v-menu>
        </v-card-actions>
        <v-divider/>
        <v-card-text v-if="question.type === 'SLIDER'">
          <translation-input :obj.sync="question" :placeholder="$tc('questions.title',1)" component-type="v-textarea"
                             field="titleTid"
                             outlined
                             prefix="f.question.title"/>
          <div class="d-flex align-center justify-center slider-indicator mt-12 mb-12">
            <v-avatar color="#ccc" size="50" style="position: absolute; left: calc(50% - (50px / 2));"></v-avatar>
            <div class="slider-line"></div>
          </div>
          <v-row>
            <v-col cols="6">
              <translation-input :obj.sync="question" :placeholder="$t('questions.slider_min_text')"
                                 component-type="v-combobox" field="sliderMinTid"
                                 outlined
                                 prefix="f.question.slider_min_text"/>
            </v-col>
            <v-col cols="6">
              <translation-input :obj.sync="question" :placeholder="$t('questions.slider_max_text')"
                                 component-type="v-combobox" field="sliderMaxTid"
                                 outlined
                                 prefix="f.question.slider_max_text"/>
            </v-col>
          </v-row>
          <v-btn v-if="isLastQuestionOfGroup" block class="mt-2" color="primary" @click="addNewQuestion">
            {{ $tc('questions.add_new_question', 1) }}
          </v-btn>
        </v-card-text>
        <v-card-text v-if="question.type === 'CHOICE_SINGLE'">
          <translation-input :obj.sync="question" :placeholder="$tc('questions.title',1)" component-type="v-text-field"
                             field="titleTid"
                             outlined
                             prefix="f.question.title"
          />
          <template v-for="(choice, choiceIdx) in question.choiceList">
            <v-row :key="choice.key">
              <v-col cols="8" offset="1">
                <translation-input :obj.sync="choice" :placeholder="$tc('questions.choice_name',1)"
                                   component-type="v-combobox"
                                   field="nameTid"
                                   outlined
                                   prefix="f.question.choice"
                />
              </v-col>
              <v-col cols="1">
                <v-text-field v-model="choice.value" :label="$t('questions.value')" outlined></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-btn icon @click="deleteChoice(choiceIdx)">
                  <v-icon>mdi mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>

          </template>
          <v-btn block color="info" @click="addChoice">{{ $t('questions.add_choice') }}</v-btn>
          <v-btn v-if="isLastQuestionOfGroup" block class="mt-2" color="primary" @click="addNewQuestion">
            {{ $tc('questions.add_new_question', 1) }}
          </v-btn>
        </v-card-text>
        <v-card-text v-if="question.type === 'GROUP'">
          <translation-input :obj.sync="question" :placeholder="$tc('questions.title',1)" component-type="v-text-field"
                             field="titleTid"
                             outlined
                             prefix="f.question.title"/>
          <translation-input :obj.sync="question" :placeholder="$tc('questions.content',1)" component-type="v-textarea"
                             field="contentTid"
                             outlined
                             prefix="f.question.content"/>
          <v-btn block class="mt-2" color="primary" @click="addNewQuestion">{{
              $tc('questions.add_new_question', 1)
            }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

</template>

<script>
import TranslationInput from "@/components/TranslationInput";

export default {
  name: "EditQuestionView",
  components: {TranslationInput},
  data() {
    return {
      /*question: {
        titleTid: null,
        contentTid: null,
        type: null,
        order: null,
        group: null,
        sliderMin: null,
        sliderMax: null,
        sliderStep: null,
        sliderMinTid: null,
        sliderMaxTid: null,
        choiceLimit: null,
        choiceList: [],
        tempKey: null,
      },*/
    }
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    types() {
      return [
        {
          value: 'SLIDER',
          label: this.$t('questions.types.SLIDER'),
        },
        {
          value: 'CHOICE_SINGLE',
          label: this.$t('questions.types.CHOICE_SINGLE'),
        },
        {
          value: 'GROUP',
          label: this.$t('questions.types.GROUP'),
          disabled: this.question.group !== null,
        }
      ]
    },
    isLastQuestionOfGroup() {
      const questionIndex = this.questions.findIndex(question => (this.question.key && question.key === this.question.key) || (this.question.tempKey && question.tempKey === this.question.tempKey));
      return !this.questions[questionIndex + 1] || this.questions[questionIndex + 1]?.group == null;
    }
  },
  methods: {
    addChoice() {
      this.question.choiceList.push({
        nameTid: null,
        choiceOrder: null,
      });
    },
    deleteChoice(choiceIdx) {
      this.question.choiceList.splice(choiceIdx, 1);
    },
    addNewQuestion() {
      let question = this.question;
      /*if (this.question.group) {
        question = this.questions.find(q => (q.tempKey === this.question.group) || (q.key === this.question.group));
      }*/
      this.$emit('add-new-question', question);
    },
    deleteQuestion() {
      this.$emit('delete-question', this.question);
    },
    duplicateQuestion() {
      this.$emit('duplicate-question', this.question);
    }
  },
  watch: {
    [`question.type`](newType, oldType) {
      console.log('changed', newType, oldType);
      if (newType === 'GROUP') {
        this.question.group = null;
      }
      if (newType === 'SLIDER') {
        this.question.sliderMin = null;
        this.question.sliderMax = null;
        this.question.sliderStep = null;
        this.question.sliderMinTid = null;
        this.question.sliderMaxTid = null;
      }
    }

  }
}
</script>

<style lang="scss" scoped>

.slider-line {
  width: 100%;
  border-bottom: 2px solid #ccc;
  height: 0px;
}

.slider-indicator {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
